import { useForm, useWatch } from "react-hook-form";
import { Button } from "../Button/Button";
import { useGlobalModalContext } from "./GlobalModal";
import { TextArea } from "../TextArea/TextArea";
import { Cause } from "../Cause/Cause";
import { MODAL_TYPES } from "common/utils/consts";
import { Title } from "../Title/Title";
import {
  useCreateDisputeMutation,
  useGetOrderCancelReasonsQuery,
} from "services/orderApi";
import { CustomInput } from "../Input/CustomInput";
import { useEffect } from "react";
import { getErrorMessage } from "common/utils/helpers";

export const DisputeModal = () => {
  const { hideModal, showModal, store } = useGlobalModalContext();
  const { modalProps } = store;
  const { orderId } = modalProps;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{ reasonId: string[]; message: string }>({
    defaultValues: { reasonId: [] },
  });

  const [createDispute, { isLoading, isSuccess, error }] =
    useCreateDisputeMutation();
  const { data: reasons } = useGetOrderCancelReasonsQuery();

  const activeReasonsId = useWatch({ control, name: "reasonId" });

  useEffect(() => {
    if (isSuccess) {
      handleModalToggle();
      showModal(MODAL_TYPES.SUCCESS_MODAL, { title: "Спор успешно открыт" });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      handleModalToggle();
      showModal(MODAL_TYPES.ERROR_MODAL, {
        title: "Ошибка при создании спора",
        subTitle: getErrorMessage(error)?.data.message,
      });
    }
  }, [error]);

  const handleModalToggle = () => {
    hideModal();
  };

  const onSubmit = handleSubmit((data) => {
    createDispute({
      order_id: orderId,
      reason_id: data.reasonId
        .filter((reason) => reason)
        .map((reason) => +reason),
      message: data.message,
    });
  });

  return (
    <div className="relative w-[320px] overflow-y-scroll rounded bg-white p-[15px]">
      <div className="mb-[25px] text-center text-lg">Открыть спор</div>
      <form onSubmit={onSubmit}>
        <div>
          <span
            className={`mb-[10px] block text-sm font-semibold ${
              !!errors.reasonId ? "text-red" : "text-gray"
            }`}
          >
            Причина
          </span>
          <ul className="mb-[5px] flex flex-wrap">
            {reasons?.map((reason, i) => (
              <li key={reason.id}>
                <CustomInput
                  type="checkbox"
                  {...register(`reasonId.${i}`, {
                    validate: (v) =>
                      activeReasonsId.filter((el) => el).length > 0,
                  })}
                  value={reason.id}
                  className="border-none p-0"
                  innerelement={
                    <Cause
                      className={`${
                        activeReasonsId.includes(String(reason.id))
                          ? "bg-primary text-white"
                          : ""
                      }`}
                    >
                      {reason.name}
                    </Cause>
                  }
                />
              </li>
            ))}
          </ul>
        </div>
        <TextArea
          {...register("message", { required: true })}
          invalid={!!errors.message}
          className="mb-[25px] h-[125px] w-full resize-none"
          placeholder="Причина"
          label="Причина спора"
        />
        <Button className="w-full" disabled={isLoading}>
          Открыть спор
        </Button>
      </form>
    </div>
  );
};
